import React from "react";
import Typist from "react-typist";

export default function About() {
  return (
    //to move directly to about section we use id
    <section id="about">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-2">
          {" "}
          <img
            className="  mx-auto h-48 w-48 object-cover object-center rounded-full"
            alt="hero"
            src="./about.jpeg"
          />
          <Typist
            cursor={{
              show: false,
              blink: false,
              element: "",
              hideWhenDoneDelay: 1000,
            }}
          >
            <h1 className="sm:text-4xl text-3xl mb-4 font-medium text-white title-font">
              Hi, I am Ritesh.
              <br className="hidden lg:inline-block" />I love To Build Things
              <Typist.Backspace count={22} delay={4000} />
            </h1>
          </Typist>
          <p className="mb-8 leading-relaxed">
            I am a undergraduate student currently pursuing my BTech in (C.S.E)
            <br />
            from NSUT East Campus( AIACTR), Delhi.
          </p>
          {/* <div className="flex justify-center">
            <a
              href="#projects"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg"
            >
              See My Past Work
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
}
